import { useEntityScope } from './useEntityScope.js';

/**
 * Returns a stable string key derived from the active scope.
 * Used in React Query queryKeys to ensure cache isolation between entities
 * (and group scope) — without this, switching from JUVO → group could serve
 * cached JUVO data because the queryKey was identical.
 *
 * Examples : 'group', 'entity:00000000-...-001', 'loading'
 */
export function useScopeKey() {
  const { isGroup, activeEntityId, isLoading } = useEntityScope();
  if (isLoading) return 'loading';
  if (isGroup) return 'group';
  if (activeEntityId) return `entity:${activeEntityId}`;
  return 'no-entity';
}
